import Styles from './UserManualForm.module.scss';
import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';
import { AivagamButton } from 'components/global/AivagamButton/AivagamButton';
import InputFileUpload from './inputFileUpload';


export function UserManualForm({ contentEditDetails, handleUMUpload, setContentEditDetails, props }) {

    const [userManualSteps, setUserManualSteps] = useState([]);
    // Create the empty step
    const emptyStep = {
        title: "",
        description: "",
        steps: "",
        uploadDone: false
    }


    // validate the user manual form
    const isFieldsEmpty = () => {
        let isEmpty = false;
        // eslint-disable-next-line array-callback-return
        userManualSteps.map((step) => {
            if (step.title === null || step.title === '' || step.description === null || step.description === '') {
                isEmpty = true;
            }

        })
        return isEmpty;
    }

    // Adding new step in the user manual step
    const addStep = (index) => {
        const newStep = { ...emptyStep, id: index }
        const updatedModulesList = [...userManualSteps, newStep];
        setUserManualSteps(updatedModulesList);
    }

    useEffect(() => {
        if (contentEditDetails.action === "edit") {
            setUserManualSteps(contentEditDetails.source);
            return;
        }
        if (userManualSteps?.length === 0) {
            addStep(1)
        } else if (userManualSteps?.length === undefined) {
            setUserManualSteps([emptyStep])
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // Update the user manual input changes 
    const handleUMFormInputChange = (inputValue, field, index) => {

        setUserManualSteps(prevSteps => {
            const updatedSteps = [...prevSteps]; // Create a copy of the array
            const updatedStep = { ...updatedSteps[index] };

            if (field === "upload") {
                updatedStep["uploadDone"] = true;
                updatedStep['file'] = inputValue;

            } else {
                updatedStep[field] = inputValue;
            }
            updatedSteps[index] = updatedStep; // Update the question at the specified index

            return updatedSteps;
        });

    };
    // Delete the steps in the user manual content
    const handleDeleteItem = (index) => {
        const updatedItems = userManualSteps.filter((_, i) => i !== index);
        setUserManualSteps([...updatedItems]);
    };

    return (
        <div id='UMFormContainer' className={Styles.UMFormContainer}>
            <p id='UMTitle' className={Styles.UMTitle}>
                User Manual
            </p>
            <div id='UMContainer' className={Styles.UMContainer}>
                {userManualSteps?.map((UMStep, index) => (
                    <>

                        <span
                            key={`${index}-UMStep`}
                            style={{ color: "black", marginLeft: "0.5em" }}>

                            <div>
                                <div style={{ display: 'flex', flexDirection: 'row', gap: '1em', padding: '0.5em', marginTop: '0.5em' }}>
                                    <div style={{ display: 'grid', alignContent: 'center', width: '69%', alignItems: 'center', }}>
                                        <TextField
                                            id={`${index}-title`}
                                            className={Styles.firstRowItem}
                                            label="Title *"
                                            placeholder="Eg. Lecture Management Guide."
                                            fullWidth={false}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            sx={{ marginBottom: '10px' }}
                                            InputProps={{
                                                maxLength: 50
                                            }}
                                            value={UMStep.title || ''}
                                            onChange={(e) => handleUMFormInputChange(e.target.value, 'title', index)}
                                        />
                                        <TextField
                                            id={`${index}-description`}
                                            className={Styles.firstRowItem}
                                            label="Description *"
                                            placeholder="Eg. This guide helps manage lectures efficiently."
                                            fullWidth={false}
                                            multiline
                                            maxRows={4}
                                            rows={2}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            sx={{ marginBottom: '10px' }}
                                            InputProps={{
                                                maxLength: 250
                                            }}
                                            value={UMStep.description || ''}
                                            onChange={(e) => handleUMFormInputChange(e.target.value, 'description', index)}
                                        />
                                        <TextField
                                            id={`${index}-steps`}
                                            className={Styles.firstRowItem}
                                            label="Steps"
                                            placeholder="Eg. 1. Introduction"
                                            multiline
                                            maxRows={4}
                                            rows={2}
                                            fullWidth={false}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            sx={{ marginBottom: '10px' }}
                                            InputProps={{
                                                maxLength: 50
                                            }}
                                            value={UMStep.steps || ''}
                                            onChange={(e) => handleUMFormInputChange(e.target.value, 'steps', index)}
                                        />
                                    </div>
                                    <div style={{ width: '25%', marginTop: '-0.4em' }}>
                                        <InputFileUpload
                                            index={index}
                                            file={UMStep?.file}
                                            maxFileSize={23437}// 3MB max
                                            handleUMFormInputChange={handleUMFormInputChange}
                                            imageFullUrl={UMStep.imageUrl}
                                        />

                                    </div>
                                    {/* Delete the steps */}
                                    {index ? <div key={index} >
                                        <button onClick={() => handleDeleteItem(index)}>❌</button>
                                    </div> : <></>}
                                </div>
                            </div>
                        </span>
                    </>

                ))}
            </div>
            <div
                id='UMBtnContainer'
                className={Styles.buttonsContainer}
            >
                <AivagamButton
                    id='cancelButton'
                    buttonText={"Close"}
                    classStyles={{ width: '8.0em' }}
                    onClick={() => {
                        setContentEditDetails({
                            type: "",
                            lectureID: ""
                        })
                    }}
                    type="cancel"
                />
                <AivagamButton
                    id='addButton'
                    buttonText={"Add Steps"}
                    onClick={() => { addStep(userManualSteps?.length + 1) }}
                    type="action"
                    disabled={userManualSteps?.length === 15}
                />
                <AivagamButton
                    id='confirmButton'
                    classStyles={{ width: '8.0em' }}
                    buttonText={contentEditDetails.action === "edit" ? "Update" : "Save"}
                    onClick={() => {
                        handleUMUpload(userManualSteps, "POST")
                    }
                }
                    type="confirm"
                    disabled={isFieldsEmpty()}
                />
            </div>
        </div>
    )
}